import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import Search from "antd/es/input/Search";
import { Filters } from "@type/core/dashboard/dashboard.types";

interface SearchFilterProps {
  selectedFilters: Filters;
  setSelectedFilters: Dispatch<SetStateAction<Filters>>;
  onSearch: () => void;
  className?: string;
}

const SearchFilter: FunctionComponent<SearchFilterProps> = ({
  selectedFilters,
  setSelectedFilters,
  onSearch,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`app-filter-search ${className}`}>
      <Search
        id="filterSearch"
        placeholder={t("home.dashboard.filters.research")}
        value={selectedFilters?.search}
        onChange={(e) => {
          e.preventDefault();
          setSelectedFilters({ ...selectedFilters, search: e.target.value });
        }}
        onSearch={onSearch}
        className="search-no-enter-button"
      />
    </div>
  );
};

export default SearchFilter;
